var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJqncXq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.463.011h13.07a1.452 1.452 0 011.453 1.452v13.07a1.452 1.452 0 01-1.453 1.452H1.463a1.452 1.452 0 01-1.452-1.452V1.463A1.452 1.452 0 011.463.011zm3.631 8.5s1.1-2.308 2.6-2.626 2.777.536 2.022 2.334a36.02 36.02 0 01-1.734 3.5 2.052 2.052 0 002.023-1.167s.652 1.208-1.445 2.042-3.471.383-2.889-.875l2.023-4.376a5.162 5.162 0 00-2.6 1.17zm4.745-5.656A1.375 1.375 0 118.5 4.232a1.358 1.358 0 011.339-1.375z",
    fill: "#02c446",
    fillRule: "evenodd"
  })));
}
export default SvgJqncXq;